// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ChooseStatus_statusBox__ZvCLj {
  display: flex;
  width: 270px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  border: 1px solid var(--border-secondary, #c8d3e0);
  background: var(--background-secondary, #fff);
  /* ◻️ Light/context_menu_shadow */
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.15);
  position: absolute;
  top: 50px;
  right: 15px;
  z-index: 2000;
}
.ChooseStatus_statusBox__ZvCLj div {
  width: 100%;
}
.ChooseStatus_statusBox__ZvCLj h1 {
  display: flex;
  height: 32px;
  padding: 9px 16px 9px 16px;
  align-items: center;
  align-self: stretch;
  color: var(--text-secondary, #5c6168);
  /* Caption 2/Regular */
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 127.273% */
  letter-spacing: -0.2px;
}
.ChooseStatus_statusBox__ZvCLj p {
  display: flex;
  height: 40px;
  padding: 11px 10px 11px 10px;
  align-items: center;
  align-self: stretch;
  gap: 7px;
  width: 100%;
  border-top: 1px solid var(--border-tertiary, #e3eaf2);
  color: var(--text-primary, #1f2023);
  /* Caption 1/Regular */
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.2px;
  cursor: pointer;
}
.ChooseStatus_statusBox__ZvCLj p b {
  color: var(--text-secondary, #5c6168);
  /* Caption 2/Regular */
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: -0.2px;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidecar/ChooseStatus/ChooseStatus.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,kDAAA;EACA,6CAAA;EAEA,iCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,aAAA;AAFD;AAIC;EACC,WAAA;AAFF;AAKC;EACC,aAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;EAGA,qCAAA;EAEA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AANF;AASC;EACC,aAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EAEA,WAAA;EAEA,qDAAA;EAEA,mCAAA;EAEA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EACA,eAAA;AAXF;AAaE;EACC,qCAAA;EAEA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAZH","sourcesContent":[".statusBox {\n\tdisplay: flex;\n\twidth: 270px;\n\tflex-direction: column;\n\talign-items: flex-start;\n\n\tborder-radius: 12px;\n\tborder: 1px solid var(--border-secondary, #c8d3e0);\n\tbackground: var(--background-secondary, #fff);\n\n\t/* ◻️ Light/context_menu_shadow */\n\tbox-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.15);\n\n\tposition: absolute;\n\ttop: 50px;\n\tright: 15px;\n\n\tz-index: 2000;\n\n\tdiv {\n\t\twidth: 100%;\n\t}\n\n\th1 {\n\t\tdisplay: flex;\n\t\theight: 32px;\n\t\tpadding: 9px 16px 9px 16px;\n\t\talign-items: center;\n\t\talign-self: stretch;\n\t\t// border-bottom: 1px solid var(--border-tertiary, #e3eaf2);\n\n\t\tcolor: var(--text-secondary, #5c6168);\n\n\t\t/* Caption 2/Regular */\n\t\tfont-family: Poppins;\n\t\tfont-size: 11px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 14px; /* 127.273% */\n\t\tletter-spacing: -0.2px;\n\t}\n\n\tp {\n\t\tdisplay: flex;\n\t\theight: 40px;\n\t\tpadding: 11px 10px 11px 10px;\n\t\talign-items: center;\n\t\talign-self: stretch;\n\t\tgap: 7px;\n\n\t\twidth: 100%;\n\n\t\tborder-top: 1px solid var(--border-tertiary, #e3eaf2);\n\n\t\tcolor: var(--text-primary, #1f2023);\n\n\t\t/* Caption 1/Regular */\n\t\tfont-family: Poppins;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 18px; /* 138.462% */\n\t\tletter-spacing: -0.2px;\n\t\tcursor: pointer;\n\n\t\tb {\n\t\t\tcolor: var(--text-secondary, #5c6168);\n\n\t\t\t/* Caption 2/Regular */\n\t\t\tfont-family: Poppins;\n\t\t\tfont-size: 11px;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 14px;\n\t\t\tletter-spacing: -0.2px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusBox": `ChooseStatus_statusBox__ZvCLj`
};
export default ___CSS_LOADER_EXPORT___;
